import { useLocation, useNavigate } from 'react-router-dom';
import './BlockedFeature.css';
import { TbBarrierBlock } from "react-icons/tb";
import { useEffect } from 'react';
import { routes } from '../../routes/routes-identity';
import { useUserStore } from '../../contexts/userStore';

export function BlockedFeature() {
	const { selectedLicenceObj } = useUserStore();
	const location = useLocation();
	const navigate = useNavigate();

	useEffect(() => {
		if (selectedLicenceObj && location.state?.ref) {
			const currentRoute = routes.find(
				(route) => route.path === location.state?.ref
			);
			if (!currentRoute) return;
			if (currentRoute.enabledBackup !== undefined && currentRoute.enabledBackup !== selectedLicenceObj?.enabledBackup) {
				return;
			}
			navigate(location.state.ref);
		}
	}, [selectedLicenceObj])

	return (
		<div className='container'>
			<div className='blocked-feature-wrapper'>
				<TbBarrierBlock size={72} color='#ff6d6d' />
				<h2>Funcionalidade bloqueada!</h2>
				<p>A sua licença não fornece acesso a essa funcionalidade.</p>
				<span>
					<span>Ref.:</span>
					<span>{location.state.feature}</span>
				</span>
			</div>
		</div>
	);
}